export const clickGame = (
  typeId: string,
  id: string,
  title: string,
  position: string
) => {
  window.gtag('event', 'click_game_card', {
    game_type: typeId,
    game_id: id,
    game_name: title,
    position: position,
  })
}

export const clickGameAuto = (
  event: string,
  typeId: string,
  id: string,
  title: string,
  position: string
) => {
  window.gtag('event', event, {
    game_type: typeId,
    game_id: id,
    game_name: title,
    position: position,
  })
}

export const clickPage = (path: string, position: string) => {
  window.gtag('event', 'click_page', {
    label: path,
    position: position,
  })
}
export const gaTrack = (event: string) => {
  window.gtag('event', event)
}
export const ttqTrack = (event: string) => {
  window.ttq.track(event)
}
